<template>
  <div>
    <b-button variant="primary" @click="modal_show=true"><b-icon icon="wallet"></b-icon> Visualizza IBAN</b-button>

    <b-modal
        centered
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc
        v-model="modal_show"
        title="Iban Atletica Taino.">

      <div class="iban-wrapper p-3 border rounded bg-light text-center">
        <input
          type="text"
          ref="ibanInput"
          :value="iban_taino"
          readonly
          class="hidden-input"
        />

        <code class="iban-display d-block mb-3">{{ iban_taino }}</code>
        <b-button
          :variant="copied ? 'success' : 'primary'"
          size="lg"
          @click="doCopy"
          class="w-100 copy-btn shadow-sm"
        >
          {{ copied ? '✅ COPIATO!' : 'COPIA NEGLI APPUNTI' }}
        </b-button>
      </div>

      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="secondary" @click="cancel()">Chiudi</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'AlertEmail',
  data () {
    return {
      iban_taino : "IT02C0873138470000000125152",
      modal_show : false,
      copied: false
    }
  },
  methods: {
    doCopy() {
      // Usiamo un elemento input reale presente nel DOM (nascosto)
      const inputEl = this.$refs.ibanInput;

      // 1. Rendiamo l'elemento temporaneamente visibile per la selezione (alcuni Android lo richiedono)
      inputEl.style.display = 'block';

      // 2. Sezione specifica per mobile
      inputEl.focus();
      inputEl.select();
      inputEl.setSelectionRange(0, 99999); // Per dispositivi iOS e Android

      try {
        // 3. Comando di copia sincrono (il più supportato)
        const successful = document.execCommand('copy');
        if (successful) {
          this.handleSuccess();
        } else {
          throw new Error('Copia fallita');
        }
      } catch (err) {
        // Ultima spiaggia: API moderna se disponibile
        if (navigator.clipboard) {
          navigator.clipboard.writeText(this.iban_taino).then(() => this.handleSuccess());
        }
      }

      // 4. Nascondiamo di nuovo l'input
      inputEl.style.display = 'none';
    },

    handleSuccess() {
      this.copied = true;
      setTimeout(() => { this.copied = false; }, 3000);
    }
  }
}
</script>

<style scoped>
/* L'input deve esistere nel DOM ma non essere visto dall'utente */
.hidden-input {
  position: absolute;
  left: -9999px;
  top: -9999px;
  opacity: 0;
  display: none;
}

.iban-display {
  word-break: break-all;
  font-family: 'Courier New', monospace;
  font-size: 1.25rem;
  font-weight: bold;
  padding: 15px;
  background: #ffffff;
  border: 2px dashed #007bff; /* Stile "ritaglio" per attirare l'attenzione */
  border-radius: 8px;
  color: #333;
}

.copy-btn {
  font-weight: 800;
  padding: 18px;
  font-size: 1.1rem;
  text-transform: uppercase;
}
</style>